export interface PetChangeRequestFieldValuesApiResource {
  name?: string;
  species?: string | null;
  breed?: string | null;
  sex?: string | null;
  date_of_birth?: string | null;
}

export interface PetChangeRequestApiResource {
  id: string;
  patient_id: string;
  patient_name: string;
  client_id: string;
  client_name: string;
  status: string;
  proposed_changes: PetChangeRequestFieldValuesApiResource;
  previous_values: PetChangeRequestFieldValuesApiResource;
  current_values: PetChangeRequestFieldValuesApiResource;
  review_note: string | null;
  reviewed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface PetChangeRequestFieldValues {
  name?: string;
  species?: string | null;
  breed?: string | null;
  sex?: string | null;
  dateOfBirth?: string | null;
}

export interface PetChangeRequest {
  id: string;
  patientId: string;
  patientName: string;
  clientId: string;
  clientName: string;
  status: string;
  proposedChanges: PetChangeRequestFieldValues;
  previousValues: PetChangeRequestFieldValues;
  currentValues: PetChangeRequestFieldValues;
  reviewNote: string | null;
  reviewedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

function mapApiResourceToPetChangeRequestFieldValues(
  resource: PetChangeRequestFieldValuesApiResource
): PetChangeRequestFieldValues {
  const values: PetChangeRequestFieldValues = {};
  if (resource.name !== undefined) {
    values.name = resource.name;
  }
  if (resource.species !== undefined) {
    values.species = resource.species;
  }
  if (resource.breed !== undefined) {
    values.breed = resource.breed;
  }
  if (resource.sex !== undefined) {
    values.sex = resource.sex;
  }
  if (resource.date_of_birth !== undefined) {
    values.dateOfBirth = resource.date_of_birth;
  }
  return values;
}

export function mapPetChangeRequestFieldValuesPayload(
  values: PetChangeRequestFieldValues
): Record<string, unknown> {
  const body: Record<string, unknown> = {};
  if (values.name !== undefined) {
    body.name = values.name;
  }
  if (values.species !== undefined) {
    body.species = values.species;
  }
  if (values.breed !== undefined) {
    body.breed = values.breed;
  }
  if (values.sex !== undefined) {
    body.sex = values.sex;
  }
  if (values.dateOfBirth !== undefined) {
    body.date_of_birth = values.dateOfBirth;
  }
  return body;
}

export function mapApiResourceToPetChangeRequest(
  resource: PetChangeRequestApiResource
): PetChangeRequest {
  return {
    id: resource.id,
    patientId: resource.patient_id,
    patientName: resource.patient_name,
    clientId: resource.client_id,
    clientName: resource.client_name,
    status: resource.status,
    proposedChanges: mapApiResourceToPetChangeRequestFieldValues(resource.proposed_changes),
    previousValues: mapApiResourceToPetChangeRequestFieldValues(resource.previous_values),
    currentValues: mapApiResourceToPetChangeRequestFieldValues(resource.current_values),
    reviewNote: resource.review_note,
    reviewedAt: resource.reviewed_at,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}
